import { useState } from 'react';
import { api } from '../lib/api.js';

export default function Login() {
  const [email, setEmail] = useState('');
  const [stage, setStage] = useState('email'); // 'email' | 'sent'
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [hint, setHint] = useState('');

  async function startAuth(e) {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      const r = await api.post('/api/auth/start', { email: email.trim().toLowerCase() });
      setStage('sent');
      setHint(r.sender === 'log'
        ? 'Dev mode: the sign-in link is printed to the server console — copy/paste from there.'
        : 'We just emailed you a sign-in link. Click it within 15 minutes.');
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-olive-900 to-olive-700 px-4">
      <div className="w-full max-w-sm">
        <div className="bg-cream-50 rounded-2xl p-8 shadow-xl">
          <div className="text-center mb-6">
            <img src="/logo.svg" alt="KingStead" className="h-16 w-16 mx-auto mb-3" />
            <div className="font-serif text-3xl text-olive-900">KingStead</div>
            <div className="text-ink-700/70 text-sm mt-1">Farms · Operations &amp; Books</div>
          </div>

          {stage === 'email' ? (
            <form onSubmit={startAuth} className="space-y-4">
              <div>
                <label className="label">Email</label>
                <input
                  className="input"
                  type="email"
                  inputMode="email"
                  autoComplete="email"
                  autoFocus
                  required
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <button className="btn-primary w-full" disabled={busy || !email}>
                {busy ? 'Sending…' : 'Send sign-in link'}
              </button>
              <p className="text-xs text-ink-700/60 text-center">
                We'll email you a one-time link. No passwords, ever.
              </p>
            </form>
          ) : (
            <div className="space-y-4 text-center">
              <div className="text-3xl">📬</div>
              <div className="text-ink-900 font-medium">Check your inbox</div>
              <div className="text-sm text-ink-700/70">
                If <span className="font-medium">{email}</span> is registered with KingStead, a sign-in link is on its way.
              </div>
              {hint && <div className="text-xs text-olive-700 bg-olive-50 rounded-md px-3 py-2">{hint}</div>}
              <button onClick={() => { setStage('email'); setErr(''); }} className="btn-ghost text-sm">Use a different email</button>
            </div>
          )}

          {err && <div className="mt-4 text-sm text-rust-700 bg-rust-500/10 rounded-md px-3 py-2">{err}</div>}
        </div>
        <div className="text-center text-cream-100/70 text-xs mt-4">
          Tate County, Mississippi · Sole proprietor
        </div>
      </div>
    </div>
  );
}
